import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as languages from "../../../../constants/languages";
import * as navigationActions from "../../../../actions/navigationActions";
import * as translationHelper from "../../../../helpers/translationHelper";
import * as modelHelper from "../../../../helpers/modelHelper";
import * as windowService from "../../../../services/windowService";

import imgDownload from "../../../../resources/img/svgicons/download.svg";
import imgExport from "../../../../resources/img/svgicons/arrow-down-circle.svg";
import imgImport from "../../../../resources/img/svgicons/import.svg";
import Modal from "../../../global/generic/Modal";
import CancelButton from "../../../global/generic/CancelButton";
import Button from "../../../global/generic/Button";
import Input from "../../../global/generic/Input";

class TranslationModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            action: null,
            detailAction: null,
            language: null,
            textarea: ""
        };
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseTranslationModalAction();
    };

    handleInputChange = (event) => {
        this.setState({textarea: event.target.value});
    };

    handleActionChange = (event) => {
        this.setState({
            action: event.target.value,
            detailAction: null,
            language: null,
            textarea: ""
        });
    };

    handleDetailActionChange = (event) => {
        this.setState({
            detailAction: event.target.value,
            language: null,
            textarea: ""
        });
    };

    handleLanguageChange = (event) => {
        this.setState({
            language: event.target.value,
            textarea: ""
        });
    };

    handleImportClick = () => {
        if (this.state.detailAction === "ini") {
            this.setState((prevState) => {
                return {textarea: translationHelper.parseIniTranslationKeys(prevState.textarea, this.state.language)};
            });
        }

        if (this.state.detailAction === "csv") {
            this.setState((prevState) => {
                return {textarea: translationHelper.parseCsvTranslationKeys(prevState.textarea, this.state.language)};
            });
        }
    };

    handleExportClick = () => {
        switch (this.state.detailAction) {
            case "csv":
                this.setState({
                    textarea: translationHelper.exportTranslationKeysToCsv(this.state.language)
                });
                break;
            case "ini":
                this.setState({
                    textarea: translationHelper.exportTranslationKeysToIni(this.state.language)
                });
                break;
            case "json":
                this.setState({
                    textarea: translationHelper.exportTranslationKeysToJson(this.state.language)
                });
                break;
            case "new":
                this.setState({
                    textarea: translationHelper.exportNewTranslationKeysToCsv(this.state.language)
                });
                break;
            default:
                break;
        }
    };

    handleSaveAsClick = () => {
        switch (this.state.detailAction) {
            case "csv":
                let header = "Key;" + this.state.language.toUpperCase() + "\n";
                windowService.openSaveTextFileDialog(
                    header + translationHelper.exportTranslationKeysToCsv(this.state.language),
                    this.state.language + ".csv"
                );
                break;
            case "ini":
                windowService.openSaveTextFileDialog(
                    translationHelper.exportTranslationKeysToIni(this.state.language),
                    this.state.language + ".ini"
                );
                break;
            case "json":
                windowService.openSaveTextFileDialog(
                    translationHelper.exportTranslationKeysToJson(this.state.language),
                    this.state.language + ".json"
                );
                break;
            case "new":
                let title = "Key;" + languages.ENGLISH.toUpperCase() + ";" + this.state.language.toUpperCase() + "\n";
                windowService.openSaveTextFileDialog(
                    title + translationHelper.exportNewTranslationKeysToCsv(this.state.language),
                    this.state.language + ".csv"
                );
                break;
            default:
                break;
        }
    };

    getActionOptions = () => {
        return (
            <div className="col-12 flex flex-wrap">
                <label className="font-normal" style={{cursor: "pointer"}}>
                    <Input
                        className="margin-right-10"
                        type="radio"
                        value="import"
                        checked={this.state.action === "import"}
                        onChange={this.handleActionChange}
                        labelAfter={<Translate value="pricing.import" />}
                    />
                </label>
                <label className="font-normal" style={{cursor: "pointer"}}>
                    <Input
                        type="radio"
                        value="export"
                        checked={this.state.action === "export"}
                        onChange={this.handleActionChange}
                        labelAfter={<Translate value="pricing.export" />}
                    />
                </label>
            </div>
        );
    };

    getDetailActionOptionsTitle = () => {
        if (this.state.action === null) {
            return "";
        }

        return <div className="col-12 flex flex-wrap text-bold">File type:</div>;
    };

    getDetailActionOptions = () => {
        if (this.state.action === null) {
            return "";
        }

        if (this.state.action === "export") {
            return (
                <div className="col-12 flex flex-wrap">
                    <label className="font-normal" style={{cursor: "pointer"}}>
                        <Input
                            className="margin-right-10"
                            type="radio"
                            value="csv"
                            checked={this.state.detailAction === "csv"}
                            onChange={this.handleDetailActionChange}
                            labelAfter={"csv"}
                        />
                    </label>

                    <label className="font-normal" style={{cursor: "pointer"}}>
                        <Input
                            className="margin-right-10"
                            type="radio"
                            value="ini"
                            checked={this.state.detailAction === "ini"}
                            onChange={this.handleDetailActionChange}
                            labelAfter={"ini"}
                        />
                    </label>

                    <label className="font-normal" style={{cursor: "pointer"}}>
                        <Input
                            className="margin-right-10"
                            type="radio"
                            value="json"
                            checked={this.state.detailAction === "json"}
                            onChange={this.handleDetailActionChange}
                            labelAfter={"json"}
                        />
                    </label>

                    <label className="font-normal" style={{cursor: "pointer"}}>
                        <Input
                            className="margin-right-10"
                            type="radio"
                            value="new"
                            checked={this.state.detailAction === "new"}
                            onChange={this.handleDetailActionChange}
                            labelAfter={"csv - new"}
                        />
                    </label>
                </div>
            );
        }

        return (
            <div className="col-12 flex flex-wrap">
                <label className="font-normal" style={{cursor: "pointer"}}>
                    <Input
                        className="margin-right-10"
                        type="radio"
                        value="csv"
                        checked={this.state.detailAction === "csv"}
                        onChange={this.handleDetailActionChange}
                        labelAfter={"csv"}
                    />
                </label>

                <label className="font-normal" style={{cursor: "pointer"}}>
                    <Input
                        className="margin-right-10"
                        type="radio"
                        value="ini"
                        checked={this.state.detailAction === "ini"}
                        onChange={this.handleDetailActionChange}
                        labelAfter={"ini"}
                    />
                </label>
            </div>
        );
    };

    getLanguageOptionList = () => {
        let languageList = [];

        let language;
        for (language of this.props.languages) {
            if (!language.custom) {
                languageList.push(
                    <div className="col-3" key={language.code}>
                        <label className="font-normal" style={{cursor: "pointer"}}>
                            <Input
                                className="margin-right-10"
                                type="radio"
                                value={language.code}
                                checked={this.state.language === language.code}
                                onChange={this.handleLanguageChange}
                                labelAfter={<Translate value={"languages." + language.code} />}
                            />
                        </label>
                    </div>
                );
            }
        }

        return languageList;
    };

    getLanguageOptionsTitle = () => {
        if (this.state.detailAction === null) {
            return "";
        }

        return (
            <div className="col-12 flex flex-wrap text-bold">
                <Translate value="navigation.menu.language" />:
            </div>
        );
    };

    getLanguageOptions = () => {
        if (this.state.detailAction === null) {
            return "";
        }

        return <div className="flex flex-wrap">{this.getLanguageOptionList()}</div>;
    };

    getNote = () => {
        if (this.state.detailAction === null) {
            return "";
        }

        if (this.state.action === "import") {
            if (this.state.detailAction === "ini") {
                return "Please insert content of *.ini file with [Global] section!";
            }

            return "";
        }

        return "";
    };

    getTextArea = () => {
        if (this.state.detailAction === null) {
            return "";
        }

        if (this.state.language === null) {
            return "";
        }

        return (
            <textarea
                className="slim-scroll width-100 min-height-20vh"
                onChange={this.handleInputChange}
                value={this.state.textarea}
            />
        );
    };

    getExportButton = () => {
        if (this.state.action === null) {
            return "";
        }

        if (this.state.action === "import") {
            if (this.state.textarea === "" || this.state.language === null || this.state.detailAction === null) {
                return <Button disabled={true} svgBefore={imgImport} label={<Translate value="pricing.import" />} />;
            }

            return (
                <Button
                    svgBefore={imgImport}
                    label={<Translate value="pricing.import" />}
                    onClick={this.handleImportClick}
                />
            );
        }
        if (this.state.language === null || this.state.detailAction === null) {
            return <Button disabled={true} svgBefore={imgExport} label={<Translate value="pricing.export" />} />;
        }

        return (
            <Button
                onClick={this.handleExportClick}
                svgBefore={imgExport}
                label={<Translate value="pricing.export" />}
            />
        );
    };

    getExportFileButton = () => {
        if (windowService.isBrowser() || this.state.action !== "export") {
            return "";
        }

        if (this.state.language === null || this.state.detailAction === null) {
            return <Button disabled={true} svgBefore={imgDownload} label={translate("general.saveAs")} />;
        }

        return <Button onClick={this.handleSaveAsClick} svgBefore={imgDownload} label={translate("general.saveAs")} />;
    };

    render() {
        return (
            <Modal
                modalId={this.props.tabId}
                header={modelHelper.buildModalSection(<Translate value="environmentsSettings.manageTranslations" />)}
                content={modelHelper.buildModalSection(
                    <React.Fragment>
                        <div className="col-12 flex flex-wrap text-bold">
                            <Translate value="machineSettings.action" />:
                        </div>
                        {this.getActionOptions()}
                        {this.getDetailActionOptionsTitle()}
                        {this.getDetailActionOptions()}
                        {this.getLanguageOptionsTitle()}
                        {this.getLanguageOptions()}
                        {this.getNote()}
                        {this.getTextArea()}
                    </React.Fragment>,
                    "flex flex-wrap"
                )}
                footer={modelHelper.buildModalSection(
                    <React.Fragment>
                        {this.getExportFileButton()}
                        {this.getExportButton()}
                        <CancelButton onClick={this.handleCloseModalClick} />
                    </React.Fragment>
                )}
                styles={{minWidth: "50%"}}
                onClose={this.handleCloseModalClick}
            />
        );
    }
}

const mapStoreToProps = (state) => {
    return {
        languages: state.lang.languages
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseTranslationModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.TRANSLATION_MODAL));
        }
    };
};

export default TranslationModal = connect(mapStoreToProps, mapDispatchToProps)(TranslationModal);
